import { LoginBackground } from "@/assets/images/login-background";
import { ResetPasswordForm } from "@/components/pages/reset-password/reset-password-form";

export const ResetPassword = ({ mode = 'reset' }: { mode?: 'reset' | 'invite' }) => {
  return (
    <div className="relative min-h-screen flex items-center justify-center">
      <LoginBackground />
      <div className="z-10">
        <ResetPasswordForm mode={mode} />
      </div>
    </div>
  );
};
